import { render, staticRenderFns } from "./ExbtSkeleton.vue?vue&type=template&id=19c82bc0&"
import script from "./ExbtSkeleton.vue?vue&type=script&lang=js&"
export * from "./ExbtSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports